import type { LucideIcon } from 'lucide-react';
import { AlertTriangle, CheckCircle2, CirclePause, Clock3 } from 'lucide-react';

export type OutreachAgentStatus = 'active' | 'paused' | 'attention' | 'provisioning' | 'archived';
export type LinkedInSessionStatus = 'connected' | 'challenge' | 'needs_login' | 'pending';
export type LeadStatus =
  | 'discovered'
  | 'qualified'
  | 'connected'
  | 'accepted'
  | 'followed_up'
  | 'attention';

export const statusMeta: Record<
  OutreachAgentStatus,
  { label: string; tone: 'green' | 'yellow' | 'red' | 'blue' | 'gray'; icon: LucideIcon }
> = {
  active: { label: 'Actif', tone: 'green', icon: CheckCircle2 },
  paused: { label: 'Pause', tone: 'yellow', icon: CirclePause },
  attention: { label: 'Attention', tone: 'red', icon: AlertTriangle },
  provisioning: { label: 'Creation', tone: 'blue', icon: Clock3 },
  archived: { label: 'Archive', tone: 'gray', icon: CirclePause },
};

export const linkedInMeta: Record<
  LinkedInSessionStatus,
  { label: string; tone: 'green' | 'yellow' | 'red' | 'gray' }
> = {
  connected: { label: 'Connecte', tone: 'green' },
  challenge: { label: 'Challenge', tone: 'red' },
  needs_login: { label: 'Login requis', tone: 'yellow' },
  pending: { label: 'En attente', tone: 'gray' },
};

export const leadStatusMeta: Record<
  LeadStatus,
  { label: string; tone: 'gray' | 'green' | 'red' | 'yellow' | 'blue' | 'purple' | 'brand' }
> = {
  discovered: { label: 'Decouvert', tone: 'gray' },
  qualified: { label: 'Qualifie', tone: 'brand' },
  connected: { label: 'Invitation', tone: 'blue' },
  accepted: { label: 'Accepte', tone: 'green' },
  followed_up: { label: 'Relance', tone: 'purple' },
  attention: { label: 'Attention', tone: 'red' },
};
